(function(){
  var TEST_KEY='st_v5_preview_cart_test';

  function testMode(){
    try{
      var url=new URL(window.location.href);
      if(url.searchParams.get('st_test')==='1'){
        sessionStorage.setItem(TEST_KEY,'1');
        return true;
      }
      return sessionStorage.getItem(TEST_KEY)==='1';
    }catch(e){
      return false;
    }
  }

  function previewHeight(){
    if(testMode()) return 230;

    var el=document.querySelector('#preview-bar-iframe, iframe[src*="preview-bar"], iframe[id*="preview"]');
    if(el){
      var h=Math.round(el.getBoundingClientRect().height||0);
      if(h>20&&h<260)return h;
    }

    try{
      if(window.Shopify&&Shopify.theme&&String(Shopify.theme.role||'').toLowerCase()!=='main'){
        return 80;
      }
    }catch(e){}

    if(location.search.indexOf('preview_theme_id=')>-1)return 80;
    return 0;
  }

  function apply(){
    var h=previewHeight();
    document.documentElement.style.setProperty('--st-preview-bar-height',h+'px');
  }

  apply();
  window.addEventListener('resize',apply,{passive:true});
  window.addEventListener('orientationchange',apply,{passive:true});
  new MutationObserver(apply).observe(document.documentElement,{childList:true,subtree:true});
  setTimeout(apply,250);
  setTimeout(apply,800);
  setTimeout(apply,1500);
})();